import { Box, TextField } from '@mui/material';
import { ChangeEventHandler } from 'react';

type Props = {
  notes: string | null | undefined;
  specialInstructions: string | null | undefined;
  additionalStickers: number | null | undefined;
  showAdditionalStickers: boolean;
  disabled: boolean;
  onChange: (patch: {
    notes?: string | null;
    specialInstructions?: string | null;
    additionalStickers?: number | null;
  }) => void;
};

export function AdditionalInformationSection({
  notes,
  specialInstructions,
  additionalStickers,
  showAdditionalStickers,
  disabled,
  onChange,
}: Props) {
  const handleAdditionalStickersChange: ChangeEventHandler<
    HTMLInputElement | HTMLTextAreaElement
  > = (event) => {
    const inputValue = event.target.value.replace(/\D/g, '');
    // convert value to number
    const numericValue = inputValue === '' ? null : Number(inputValue);
    onChange({
      additionalStickers: numericValue,
    });
  };

  return (
    <Box sx={{ display: 'flex', flexDirection: 'column', gap: 2 }}>
      {showAdditionalStickers && (
        <TextField
          variant='outlined'
          label='Request Additional Sign Stickers'
          helperText='Enter number of additional stickers, leave blank if none'
          inputProps={{
            inputMode: 'numeric',
            pattern: '[0-9]*',
            maxLength: 1000,
          }}
          value={additionalStickers ?? ''}
          id='additional-stickers'
          name='additional-stickers'
          onChange={handleAdditionalStickersChange}
          disabled={disabled}
        />
      )}

      <TextField
        label='Notes'
        value={notes ?? ''}
        onChange={(event) =>
          onChange({
            notes: event.target.value === '' ? null : event.target.value,
          })
        }
        id='adf-notes'
        variant='outlined'
        fullWidth
        multiline
        minRows={4}
        disabled={disabled}
      />

      <TextField
        label='Special Instructions'
        value={specialInstructions ?? ''}
        onChange={(event) =>
          onChange({
            specialInstructions: event.target.value === '' ? null : event.target.value,
          })
        }
        id='special-instructions'
        variant='outlined'
        fullWidth
        multiline
        minRows={4}
        disabled={disabled}
      />
    </Box>
  );
}
